export default "__VITE_ASSET__lVQ6wPKy__"